import { SyntheticEvent } from 'react';
import cn from 'classnames';
import classNames from 'classnames/bind';
import { Icon } from 'ht-styleguide';
import styles from './slidemodalheader.module.scss';

type ModalHeaderProps = {
  handleClose: BaseAnyFunction;
  showLogo?: boolean;
  buttonStyle?: string;
  headerStyles?: string;
};

const ModalHeader = ({ showLogo = true, buttonStyle, headerStyles, handleClose }: ModalHeaderProps) => {
  const handleCloseFn = (event: SyntheticEvent) => {
    event.preventDefault();
    handleClose();
  };

  const cx = classNames.bind(styles);

  const closeClasses = cx({
    close: true,
    ...(buttonStyle && { [buttonStyle]: !!buttonStyle }),
  });

  const headerStyle = cx({
    header: true,
    ...(headerStyles && { [headerStyles]: true }),
  });

  return (
    <div className={headerStyle}>
      {showLogo && (
        <div className={`flex alignItemsCenter justifyContentCenter ${styles.logoOuterWrapper}`}>
          <Icon name="logo" className={styles.logo} />
        </div>
      )}
      <button type="button" className={cn('plainButton text-link -no-decoration', styles.modalCloseContainer, closeClasses)} onClick={handleCloseFn}>
        <Icon name="v2-close-icon" className={styles.modalCloseIcon} />
      </button>
    </div>
  );
};

export default ModalHeader;
